(function() {
    'use strict';

    angular
        .module('completeAir')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', '$timeout', 'Account'];

    function Principal($q, $timeout, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            isInRole: isInRole,
            isInAnyRole: isInAnyRole,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };
        return service;

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity != null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.roles) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.roles.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isInRole(role) {
            if (!_authenticated || !_identity.roles) return false;
            return _identity.roles.indexOf(role) !== -1;
        }

        function isInAnyRole(roles) {
            if (!_authenticated || !_identity.roles) return false;

            for (var i = 0; i < roles.lenght; i++) {
                if (this.isInRole(roles[i])) return true;
            }
        }

        function identity(force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);
                return deferred.promise;
            }

            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }
    }

})();
